import {
	DropsPage,
	getDropsServerSideProps,
} from 'root/src/client/v2/_pages/drops'

export const getServerSideProps = getDropsServerSideProps

export default DropsPage
